import React from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import * as api from "../../../services/api";
import * as qs from "../../../qs";
import * as p from "../../../parser";
import { useLatest } from "../../../hooks";
import { TablePagination } from "../../table";
import * as f from "../../../utils/formatter";
import * as d from "shared/src/date.mjs";
import { ChangedFields, RowData } from "../../history";

const defaults = [
  [["page", "limit"], 25],
  [["page", "offset"], 0],
];

const parsers = [
  [["page", "limit"], (val) => p.parseInt(val, 10)],
  [["page", "offset"], (val) => p.parseInt(val, 0)],
];

function graphqlArgs(request, clientId) {
  const parsedArgs = qs.parse(new URL(request.url).searchParams.toString(), {
    defaults: defaults,
    parsers: parsers,
  });

  parsedArgs.filter = {
    relid: { eq: "client" },
    row_data: { name: "id", expr: { eq: clientId } },
  };

  return parsedArgs;
}

function useData(clientId) {
  const [state, setState] = React.useState({ result: null, loading: true });

  useLatest(
    async (signal) => {
      const request = { url: window.location.href };

      setState((state) => ({ ...state, loading: true }));
      try {
        const result = await api.loadClientHistory(
          graphqlArgs(request, clientId),
          {
            signal,
          },
        );

        setState((state) => ({ ...state, result }));
      } finally {
        if (!signal.aborted) {
          setState((state) => ({ ...state, loading: false }));
        }
      }
    },
    [window.location.href],
  );

  return state;
}

const actions = {
  I: "Vytvoření",
  U: "Úprava",
  T: "Smazání",
  D: "Smazání",
};

function Content({ auditConnection }) {
  return (
    <>
      <Card>
        <CardContent>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Datum</TableCell>
                  <TableCell>Uživatel</TableCell>
                  <TableCell>Typ</TableCell>
                  <TableCell>Akce</TableCell>
                  <TableCell>Stará data</TableCell>
                  <TableCell>Upravená data</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {auditConnection.data.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      {f.date(d.parseUtcDateTime(row.created_at))}
                    </TableCell>
                    <TableCell>{row.user_name}</TableCell>
                    <TableCell>{row.relid}</TableCell>
                    <TableCell>{actions[row.action] ?? row.action}</TableCell>
                    <TableCell>
                      <RowData audit={row} />
                    </TableCell>
                    <TableCell>
                      <ChangedFields audit={row} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <TablePagination connection={auditConnection} component="div" />
          </Box>
        </CardContent>
      </Card>
    </>
  );
}

export default function History({ clientId }) {
  const data = useData(clientId);

  if (data.loading) {
    return <CircularProgress sx={{ m: 4 }} />;
  }

  return <Content auditConnection={data.result.data.audit} />;
}
